import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { getFullPath } from '../lib/get-full-path';
import { removeIdPrefix } from '../lib/remove-id-prefix';
import { PICFLOW_CONFIG } from '../picflow-config';

@Injectable({
  providedIn: 'root',
})
export class GalleryUrlService {
  private config = inject(PICFLOW_CONFIG);
  private route = inject(ActivatedRoute);

  public getParentPath(parent: GalleryDto) {
    const path = getFullPath(this.route.snapshot);
    const isTenantDomain = this.config.isTenantDomain;
    const isSlashA = path[0] === 'a';
    if (isTenantDomain) return ['/' + parent.path, ...this.getExtraPath(path)];
    if (isSlashA) return ['/a', 'gallery', removeIdPrefix(parent.id), ...this.getExtraPath(path)];
    return ['/gallery', parent.id, ...this.getExtraPath(path)];
  }

  public getChildPath(parent: GalleryDto, child: GalleryDto) {
    const path = getFullPath(this.route.snapshot);
    const isTenantDomain = this.config.isTenantDomain;
    const isSlashA = path[0] === 'a';
    if (isTenantDomain) return ['/' + parent.path, child.path, ...this.getExtraPath(path)];
    if (isSlashA) return ['/a', 'gallery', removeIdPrefix(child.id), ...this.getExtraPath(path)];
    return ['/gallery', parent.id, child.id, ...this.getExtraPath(path)];
  }

  private getExtraPath(path: string[]) {
    const extra: string[] = [];
    ['embed', 'advanced'].forEach(string => {
      if (path.includes(string)) extra.push(string);
    });
    return extra;
  }
}
